// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"215":"741f74ad","428":"d43f5553","736":"14699211","847":"c0c36552"}[chunkId] + ".css";
};